module.exports = __webpack_public_path__ + "img/under_construction.37ade1b6.svg";